import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const StripContainer = styled.div<{ $backgroundColor?: string }>(({ theme, $backgroundColor }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: `${theme.spacing.xSmall} ${theme.spacing.medium}`,
    background: $backgroundColor,
}));

export const StripText = styled(Text)`
    text-align: center;
`;
